import React, { useState } from 'react'
import { Section4Data } from '../../constants'
import { useStateContext } from '../../context/ContextProvider'
import { truncateText } from "../hooks/TextVeiw"
import SmallButton from '../layout/SmallButton'
import { IoIosCloseCircleOutline } from "../icons"
import {BackgroundBeams} from '../ui/BackgroundBeams';
const Section4Home = () => {
    const { currentLang } = useStateContext()
    const [open, setOpen] = useState(false)
    const [openId, setOpenId] = useState(null)

    const handleClose = () => {
        setOpen(false)
        setOpenId(null)
    }

    return (
        <div className=" w-full rounded-md  relative flex flex-col items-center justify-center antialiased">
        <section className='mt-12 z-10  md:mt-16 lg:mt-20 container'>
            <div className="flex flex-col w-full items-center py-4 gap-6">
                <div className="flex w-full mb-6 items-start">
                    <h2 className="h3 text-light-blue dark:text-dark-title">
                        {currentLang === "ar" ? Section4Data.title_Ar : Section4Data.title_En}
                    </h2>
                </div>
                <div className="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6">
                    {Section4Data.cards.map((card) => {
const descAr =  truncateText( card.description_Ar ,22)
const descEn =  truncateText( card.description_En ,17 )
                        return(
                        <div
                            key={card.id}
                            onClick={() => {
                                setOpen(true)
                                setOpenId(card.id)
                            }}
                            style={{
                                backgroundImage: `url(${card.background})`,
                                backgroundSize: 'cover',
                                backgroundWidth: '100%',
                                backgroundRepeat: 'no-repeat',
                            }}
                            className="flex flex-col hover:shadow-xl hover:shadow-light-blueGlass1 w-[300px] h-[300px] items-start gap-4 p-6 bg-gradient-to-br from-light-glass1  to-light-glass2 dark:from-dark-glass1  dark:to-dark-glass2 border border-light-glassStrock2 dark:border-dark-glassStrock1  rounded-3xl backdrop-blur-xl cursor-pointer"
                        >
                            <img src={card.icon} alt={currentLang === "ar" ? card.title_Ar : card.title_En} className='w-12 h-12' />
                            <h3 className="h6 text-light-title dark:text-dark-title">
                                {currentLang === "ar" ? card.title_Ar : card.title_En}
                            </h3>
                            <p className="body-2 text-light-title dark:text-dark-title ">
                                {currentLang === "ar" ? descAr : descEn }
                            </p>
                        </div>
                    )})}
                </div>

                {open && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="relative flex pt-10 items-center justify-center">
                            {Section4Data.cards.map((card) => (
                                card.id === openId && (
                                    <div
                                        key={card.id}
                                      
                                        className="flex flex-col lg:w-[500px] w-[300px]   h-auto bg-light-glass1 items-start gap-4 p-6 dark:bg-dark-glass1 border border-light-glassStrock1  backdrop-blur-xl rounded-[35px]"
                                    >
                                        <div className="flex w-full items-center justify-between">
                                            <SmallButton onClick={handleClose}>
                                                <IoIosCloseCircleOutline size={30} />
                                            </SmallButton>
                                            <img src={card.icon} alt={currentLang === "ar" ? card.title_Ar : card.title_En} className='w-12 h-12' />
                                        </div>
                                        <h3 className="h5 text-light-title dark:text-dark-title">
                                            {currentLang === "ar" ? card.title_Ar : card.title_En}
                                        </h3>
                                        <p className="body-1   text-light-title dark:text-dark-subtitle leading-relaxed">
    {currentLang === "ar" ? card.description_Ar : card.description_En}
</p>
                                    </div>
                                )
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </section>
        <BackgroundBeams />
    </div>
    );

}

export default Section4Home

